import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="radio"
export default class extends Controller {
  static targets = [ 'input', 'title' ]
  static values = {
    url: String
  }
  
  connect() {
  }

  toggle(element) {
    let value = element.currentTarget.value
    let link_element = document.getElementById('link-share')
    link_element.innerHTML = link_element.innerHTML.replace(/([^\/]+$)/, value)
  }

  goto(element) {
    let list = document.querySelectorAll("input[data-action='radio#goto']")
    list.forEach((item) => {
      item.checked = false
    })
    element.currentTarget.checked = true
    console.log(element.currentTarget)
    console.log(element.currentTarget.dataset)
    console.log(element.currentTarget.dataset.urlValue);
    // window.location = element.currentTarget.dataset.urlValue;
  }

  activeClick(ele) {
    let role = ''
    let element = ''
    ele.preventDefault()
    console.log('Hello')
    if (ele.currentTarget instanceof HTMLInputElement) {
      // element = ele.currentTarget
      role = ele.currentTarget.closest('.radio-container').querySelector('label').attributes.for.value
    } else {
      role = ele.currentTarget.attributes.for.value
    }
    const input = ele.currentTarget.closest('.radio-container').querySelector(`input[value="${role}"]`);
    console.log(role)
    console.log(input)
    if (input) {
      input.click()
    }
  }
}
